export const DevicesList = {
    MOBILE_REGISTRATION: ['PREPAID', 'POSTPAID'],
    FIXEDLINE_REGISTRATION: ['FIXED_LINE'],
    COMPLAINT: ['PREPAID', 'POSTPAID', 'FIXED_LINE']
}